module.exports = __webpack_public_path__ + "static/media/hu.85015780.svg";